import { BBAPISubError } from "./api-sub-error";

export class BBAPIError{
     status: string;
     timestamp: Date ;
     message: string ;
     title: string;
     errors: Array<BBAPISubError>;
}